module.exports = __webpack_public_path__ + "static/img/main5_1.2ea8475d.png";